"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var primitiveTypes = ['char', 'byte', 'bool', 'int8', 'uint8', 'int16', 'uint16', 'int32', 'uint32', 'int64', 'uint64', 'float32', 'float64', 'string', 'time', 'duration'];

function isPrimitive(fieldType) {
  return primitiveTypes.indexOf(fieldType) >= 0;
}

function isArray(fieldType) {
  var isArrayRegex = /.*\[*\]$/;
  return fieldType.match(isArrayRegex) !== null;
}

function isMessage(fieldType) {
  return !isPrimitive(fieldType) && !isArray(fieldType);
}

function parsePrimitive(fieldType, fieldValue) {
  var parsedValue = fieldValue;

  if (fieldType === 'bool') {
    parsedValue = fieldValue === '1';
  } else if (fieldType === 'int8' || fieldType === 'byte') {
    parsedValue = parseInt(fieldValue);
  } else if (fieldType === 'uint8' || fieldType === 'char') {
    parsedValue = parseInt(fieldValue);
    parsedValue = Math.abs(parsedValue);
  } else if (fieldType === 'int16') {
    parsedValue = parseInt(fieldValue);
  } else if (fieldType === 'uint16') {
    parsedValue = parseInt(fieldValue);
    parsedValue = Math.abs(parsedValue);
  } else if (fieldType === 'int32') {
    parsedValue = parseInt(fieldValue);
  } else if (fieldType === 'uint32') {
    parsedValue = parseInt(fieldValue);
    parsedValue = Math.abs(parsedValue);
  } else if (fieldType === 'int64') {
    throw new Error('int64 and uint64 are currently unsupported field types.');
  } else if (fieldType === 'uint64') {
    throw new Error('int64 and uint64 are currently unsupported field types.');
  } else if (fieldType === 'float32') {
    parsedValue = parseFloat(fieldValue);
  } else if (fieldType === 'float64') {
    parsedValue = parseFloat(fieldValue);
  }

  return parsedValue;
}

var _default = {
  primitiveTypes: primitiveTypes,
  isPrimitive: isPrimitive,
  isArray: isArray,
  isMessage: isMessage,
  parsePrimitive: parsePrimitive
};
exports["default"] = _default;